import { Injectable } from '@angular/core';
import { getUrlParameterByName } from '../api/HelperFunctions';

@Injectable({
  providedIn: 'root'
})
export class PreLoginScriptService {
  private _loaded = false;

  get isLoaded(): boolean {
    return this._loaded;
  }

  async loadPreLoginScript() {
    if (this._loaded) {
      return;
    }

    try {
      const scriptURL = getUrlParameterByName('preloginJSURL');
      if (scriptURL) {
        const promise = new Promise<void>((resolve, reject) => {
          const script = document.createElement('script');
          script.src = scriptURL;
          script.setAttribute('data-name', 'preloginscript');
          script.type = 'application/javascript';
          const timeout = window.setTimeout(() => {
            reject('Failed to load script! url=' + scriptURL);
          }, 50000);
          script.onload = () => {
            window.clearTimeout(timeout);
            resolve();
          };
          document.head.appendChild(script);
        });

        await promise;
        this._loaded = true;
      }
    } catch (e: any) {
      console.log('Error handling prelogin loadScript operation! Error=' + e.message);
    }
  }
}
